import { Ajax } from "../../Common/Ajax";
import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";

class CreateReasonToSellModel {
    public symbols: string[] = [];
    public sellCriteria: SellCriterion[] = [];
}

class SellCriterion {
    public sellCriterionId: number | null = null;
    public description: string | null = null;
    public defaultValue: number | null = null;
}

class LotDetailsModel {
    public dateOpen: string | null = null;
    public quantity: number | null = null;
}

class ReasonsToSellModel {
    public SellCriterionId: number | null = null;
    public Value: number | null = null;
    public CriterionMet: boolean | null = null;
    public Acknowledged: boolean | null = null;
    public Account: string | null = null;
    public Symbol: string | null = null;
    public DateOpen: string | null = null;
}

export class ReasonsToSell {
    public static readonly GRID = '#reasonsToSellGrid';
    public static readonly CREATE_SYMBOL = '#reasonToSellSymbol';
    public static readonly CREATE_LOTS = '#reasonToSellLots';
    public static readonly CREATE_DESCRIPTION = '#reasonToSellDescription';
    public static readonly CREATE_VALUE = '#reasonToSellValue';
    public static readonly CREATE_BUTTON = '#createReasonToSellButton';

    private grid!: kendo.ui.Grid;
    private sellCriteria: SellCriterion[] = [];

    private static _instance: ReasonsToSell;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {}

    public init() {
        if (this.grid) {
            this.grid.destroy();
            $(ReasonsToSell.GRID).empty();
        }
        this.initGrid();

        this.initCreate();
    }

    private initGrid() {
        const dataSource: any = {
            transport: {
                read: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL +
                    '?account=' + CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE),
                update: {
                    url: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL +
                        '?account=' + CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE),
                    type: 'PUT',
                    contentType: 'application/json',
                    dataType: 'json',
                },
                parameterMap: function (options: any, operation: any) {
                    if (operation !== "read" && options.models) {
                        return kendo.stringify(options.models);
                    }
                }
            },
            batch: true,
            serverPaging: false,
            serverSorting: false,
        };

        this.grid = $(ReasonsToSell.GRID).kendoGrid({
            dataSource: dataSource,
            dataBound: () => {
                this.defineEvents();

                $(ReasonsToSell.GRID).show();
            },

            height: 915,
            groupable: false,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            columns: [
                {
                    field: 'reasonToSellId',
                    hidden: true,
                },
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '20%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "dateOpen",
                    title: "Date Open",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('dateOpen')),
                },
                {
                    field: "description",
                    title: "Reason to Sell",
                    width: '30%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "criterionMet",
                    title: "Met?",
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getRedBoolTemplate("criterionMet")),
                },
                {
                    width: '3%',
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getDeleteButtonTemplate('../images', 'reasonToSellId')),
                }
            ]
        }).data('kendoGrid')!;
    }

    private initCreate() {
        const success = (data: CreateReasonToSellModel) => {
            if (data && data.symbols) {
                $(ReasonsToSell.CREATE_SYMBOL).find('option').remove().end();
                this.addSelectOption(ReasonsToSell.CREATE_SYMBOL, '0', 'Select...');
                for (const symbol of data.symbols) {
                    this.addSelectOption(ReasonsToSell.CREATE_SYMBOL, symbol, symbol);
                }
            }

            if (data && data.sellCriteria) {
                $(ReasonsToSell.CREATE_DESCRIPTION).find('option').remove().end();
                this.addSelectOption(ReasonsToSell.CREATE_DESCRIPTION, 0, 'Select...');
                for (const sellCriterion of data.sellCriteria) {
                    this.addSelectOption(ReasonsToSell.CREATE_DESCRIPTION,
                        sellCriterion.sellCriterionId, sellCriterion.description);
                }

                this.sellCriteria = data.sellCriteria;
            }

            this.defineCreateEvents();
        };

        const error = (x: any) => {
            const msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL +
            '/create?account=' + CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE),
            'GET', null, success, error);
    }

    private addSelectOption(elementId: string, value: string | number | null, text: string | null) {
        $(elementId).append($('<option>', {
            value: value,
            text: text,
        }));
    }

    private defineEvents() {
        const deleteButtonClass = TemplateHelpers.getDeleteButtonClass();
        $('.' + deleteButtonClass).off('click').on('click', (e: any) => {
            this.onDeleteClick(e);
        });
    }

    private defineCreateEvents() {
        $(ReasonsToSell.CREATE_SYMBOL).off('change').on('change', (e: any) => {
            this.updateLots(e.currentTarget.value);
        });

        $(ReasonsToSell.CREATE_DESCRIPTION).off('change').on('change', (e: any) => {
            let found = false;
            for (const criterion of this.sellCriteria) {
                if (criterion.sellCriterionId == e.currentTarget.value &&
                    criterion.defaultValue !== null) {

                    $(ReasonsToSell.CREATE_VALUE).val(criterion.defaultValue);
                    found = true;
                    break;
                }
            }
            if (!found) {
                $(ReasonsToSell.CREATE_VALUE).val('');
            }
        });

        $(ReasonsToSell.CREATE_BUTTON).off('click').on('click', () => {
            const model = new ReasonsToSellModel();
            model.Symbol = $(ReasonsToSell.CREATE_SYMBOL + ' option:selected').val()?.toString() || '';
            model.Account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
            model.DateOpen = $(ReasonsToSell.CREATE_LOTS + ' option:selected')?.val()?.toString() || null;
            if (model.DateOpen == '0') {
                model.DateOpen = null;
            }
            model.SellCriterionId = $(ReasonsToSell.CREATE_DESCRIPTION + ' option:selected').val() as number;
            model.Value = $(ReasonsToSell.CREATE_VALUE).val() as number;
            model.CriterionMet = false;
            model.Acknowledged = false;

            const success = () => {
                this.grid.dataSource.read();
            };

            const error = (x: any) => {
                const msg = new Notification();
                msg.error(x.responseJSON);
            };

            Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL,
                'POST', model, success, error);
        });
    }

    private updateLots(symbol: string) {
        const success = (data: LotDetailsModel[]) => {
            $(ReasonsToSell.CREATE_LOTS).find('option').remove().end();
            for (const lot of data) {
                this.addSelectOption(ReasonsToSell.CREATE_LOTS, lot.dateOpen,
                    HtmlHelpers.getFormattedDate(lot.dateOpen) + ', ' + lot.quantity);
            }
            this.addSelectOption(ReasonsToSell.CREATE_LOTS, 0, 'New Lot');
        };

        const error = (x: any) => {
            const msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL +
            '/lots?account=' + CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE) +
            '&symbol=' + symbol, 'GET', null, success, error);
    }

    private onDeleteClick(e: any) {
        const deleteButtonClass = TemplateHelpers.getDeleteButtonClass();
        const reasonToSellId = e.currentTarget.id.substr(deleteButtonClass.length);
        const data = $(ReasonsToSell.GRID).data("kendoGrid")!.dataSource.data();
        let symbol = '';
        let dateOpen = '';
        for (let i = 0; i < data.length; ++i) {
            if (data[i].reasonToSellId == reasonToSellId) {
                symbol = data[i].symbol;
                dateOpen = HtmlHelpers.getFormattedDate(data[i].dateOpen);
                break;
            }
        }

        kendo.confirm('Are you sure that you want to delete ' + symbol + ' from ' + dateOpen + '?')
            .then(() => {
                this.deleteRow(reasonToSellId);
            });
    }

    private deleteRow(reasonToSellId: string) {
        const success = () => {
            this.grid.dataSource.read();
        };

        const error = (x: any) => {
            const msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_REASONS_TO_SELL +
            '?reasonToSellId=' + reasonToSellId, 'DELETE', null, success, error);
    }
}
